import React, { useEffect, useState } from 'react';
import Modal from '@parchment/modal';
import styled from 'styled-components';
import { Image, java, white } from '@parchment/atoms';
import { CancelIcon } from '@parchment/icons';
export default function ImagePreview(props) {
  const [imageSrc, setImageUrl] = useState();
  const [imageWidth, setImageWidth] = useState('auto');
  const [imageHeight, setImageHeight] = useState('auto');
  useEffect(() => {
    if (props.image) {
      if (typeof props.image === 'object') {
        const reader = new FileReader();
        reader.onload = () => {
          setImageUrl(reader.result);
        };
        reader.readAsDataURL(props.image);
      } else {
        setImageUrl(props.image);
      }
    }
  }, [props.image]);
  const fitToContainer = (widthOfImage, widthOfContainer, heightOfImage, heightOfContainer) => {
    const largeWidth = Math.max(widthOfImage, widthOfContainer);
    const smallWidth = Math.min(widthOfImage, widthOfContainer);
    const largeHeight = Math.max(heightOfImage, heightOfContainer);
    const smallHeight = Math.min(heightOfImage, heightOfContainer);
    let i = largeWidth;
    while (i % smallWidth !== 0) {
      i += largeWidth;
    }
    const adjustedHeight = i / smallWidth * smallHeight;
    let height, width;
    if (adjustedHeight > largeHeight) {
      height = '400px';
      width = widthOfImage * 400 / heightOfImage + 'px';
    } else {
      height = heightOfImage * 680 / widthOfImage + 'px';
      width = '680px';
    }
    return {
      width,
      height
    };
  };
  const handleImageLoad = e => {
    const target = e.target;
    const {
      width,
      height
    } = fitToContainer(parseInt(target.width), 680, parseInt(target.height), 400);
    setImageWidth(width);
    setImageHeight(height);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    open: props.show,
    onClose: props.onClose,
    ariaLabel: props.ariaLabel
  }, /*#__PURE__*/React.createElement(Container, null, props.isSVG ? /*#__PURE__*/React.createElement(StyledSVG, {
    role: "img",
    viewBox: '0 0 680 400'
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: imageSrc,
    width: "680",
    height: "400",
    preserveAspectRatio: "xMidYMid meet"
  })) : /*#__PURE__*/React.createElement(ImageWrapper, {
    width: imageWidth,
    height: imageHeight
  }, /*#__PURE__*/React.createElement(StyledImage, {
    src: imageSrc,
    alt: props.ariaLabel,
    onLoad: handleImageLoad,
    onChange: handleImageLoad,
    width: imageWidth,
    height: imageHeight
  })), /*#__PURE__*/React.createElement(ButtonWrapper, {
    role: "button",
    onClick: () => props.onClose && props.onClose()
  }, /*#__PURE__*/React.createElement(CancelIcon, {
    color: java
  })))));
}
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImagePreview__Container",
  componentId: "mr1l8d-0"
})(["position:relative;width:100%;height:100%;"]);
const ButtonWrapper = /*#__PURE__*/styled.button.withConfig({
  displayName: "ImagePreview__ButtonWrapper",
  componentId: "mr1l8d-1"
})(["position:absolute;top:-2em;right:-2em;&:hover svg{color:", "}&:hover{background:", ";cursor:pointer;}height:35px;width:35px;font-size:16px;border-radius:100%;border-style:none;border-width:0;background-color:transparent;"], white, java);
const ImageWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImagePreview__ImageWrapper",
  componentId: "mr1l8d-2"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:", ";height:", ";"], props => props.width || 'auto', props => props.height || 'auto');
const StyledImage = /*#__PURE__*/styled(Image).withConfig({
  displayName: "ImagePreview__StyledImage",
  componentId: "mr1l8d-3"
})(["display:block;width:", ";height:", ";object-fit:contain;background-image:linear-gradient(45deg,#808080 25%,transparent 25%),linear-gradient(-45deg,#808080 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#808080 75%),linear-gradient(-45deg,transparent 75%,#808080 75%);background-size:20px 20px;background-position:0 0,0 10px,10px -10px,-10px 0px;"], props => props.width || 'auto', props => props.height || 'auto');
const StyledSVG = /*#__PURE__*/styled.svg.withConfig({
  displayName: "ImagePreview__StyledSVG",
  componentId: "mr1l8d-4"
})(["background-image:linear-gradient(45deg,#808080 25%,transparent 25%),linear-gradient(-45deg,#808080 25%,transparent 25%),linear-gradient(45deg,transparent 75%,#808080 75%),linear-gradient(-45deg,transparent 75%,#808080 75%);background-size:20px 20px;background-position:0 0,0 10px,10px -10px,-10px 0px;"]);